import React from 'react';
import { Outlet, useLocation } from 'react-router';
import { useAuth } from '../providers/AuthProvider';
import { GuestLayout } from './GuestLayout';
import { LoggedLayout } from './LoggedLayout';
import { UserProjectLayout } from './UserProjectLayout';
import { useRole } from '../providers/RoleProvider';
import { ProjectProvider } from '../modules/project';

export const AppLayout: React.FC = () => {
  const { loggedIn } = useAuth();
  const { activeRole } = useRole();
  const location = useLocation();
  const isProjectPath = location.pathname.startsWith('/project');
  const projectPathMatch = location.pathname.match(/^\/project\/([^/]+)(?:\/phase\/[^/]+)?/);
  const projectId = projectPathMatch?.[1];

  if (!loggedIn) {
    return (
      <GuestLayout>
        <Outlet />
      </GuestLayout>
    );
  }

  if (activeRole === 'USER' || isProjectPath) {
    return (
      <ProjectProvider projectId={projectId}>
        <UserProjectLayout>
          <Outlet />
        </UserProjectLayout>
      </ProjectProvider>
    );
  }

  return (
    <LoggedLayout>
      <Outlet />
    </LoggedLayout>
  );
};
